import { Box, Grid, Typography } from "@mui/material";
import avatar2 from "assets/splashpage/alexandra.png";
import avatar3 from "assets/splashpage/carmina.png";
import avatar1 from "assets/splashpage/just_jasing_2.jpg";
import pic from "assets/splashpage/va_splash_page.webp";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { SplashPage } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";
import { HEART_COLOR } from "styles/oneOffColor";

import { getSource } from "utils/tracking";
import { useSubscription } from "utils/useSubscription";

import SplashPageHome from "../components/Home";

const VaPlanSplashPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const source = getSource();
  const { setAlert } = useContext(AlertContext);
  const { currentOrg } = useContext(OrganizationUserContext);

  const { handleCheckout } = useSubscription();

  const checkOutForSplashPage = (plan: Plans) => {
    if (currentOrg?.isVaUser) {
      setAlert(
        "You already subscribed. Please go to Settings page to manage your subscription.",
        "info",
      );
      navigate(`/${routes.home}${location.search}`, { replace: true });
    } else {
      handleCheckout(
        Plans.VA_YEARLY,
        source || "",
        window.location.pathname,
        SplashPage.va,
      );
    }
  };

  const renderReview = (
    avatar: string,
    username: string,
    description: string,
  ) => {
    return (
      <>
        <Grid
          container
          alignItems="flex-start"
          sx={{
            backgroundColor: "white",
            p: 1,
            borderRadius: 1,

            boxShadow: 1,
          }}
          gap={2}
        >
          <Grid container justifyContent="center" item xs={1.5} sm={1} lg={2}>
            <Box
              component="img"
              src={avatar}
              sx={{ width: 50, height: 50, borderRadius: 100 }}
            />
          </Grid>
          <Grid item xs>
            <Typography>
              <strong>{username}</strong> {description}
            </Typography>
          </Grid>
          <Box
            component="i"
            className="fa-solid fa-heart"
            sx={{ color: HEART_COLOR, mt: 4 }}
          />
        </Grid>
      </>
    );
  };

  return (
    <SplashPageHome
      checkOutForSplashPage={checkOutForSplashPage}
      sidebarPic={pic}
      planDetails={
        <>
          <Typography variant="h2">Bento's Virtual Assistant</Typography>
          <Typography variant="h6">
            Spend less time. Make more money.
          </Typography>

          <Typography>
            Your AI-powered agent pitches you to 300+ brands every month and
            handles the follow-ups - so you can focus on creating, not chasing.
          </Typography>

          <Box sx={{ mt: 6 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>Why Creators Love It</strong>
            </Typography>
            🟢 <strong>Quick Onboarding </strong> Sign up with just 1 simple
            form
            <br />
            🟢 <strong>Automated Outreach</strong> 300+ personalized brand
            pitches send every month
            <br />
            🟢 <strong>Follow-ups That Work </strong>Hundred of smart follow-up
            emails handled for you
            <br />
            🟢 <strong>Never Miss a Brand </strong>Automatic repitchings to
            companies you love <br />
            🟢 <strong>Cancel Anytime </strong>No contracts, no lock-ins. Just
            total flexibility <br />
            🟢 <strong>Real Human Backup </strong>High-touch support whenver you
            need it <br />
          </Box>

          <Box sx={{ mt: 3 }}>
            <Typography sx={{ mb: 2 }}>
              <strong>The Results</strong>
            </Typography>
            <Typography>
              🚀 Virtual Assistant members are{" "}
              <Box sx={{ color: "success.light" }} component="span">
                <strong>33x more likely</strong>
              </Box>{" "}
              to land a brand deals than other creators on Bento
            </Typography>
          </Box>

          <Grid container gap={2} sx={{ my: 6 }}>
            <Grid item xs={12} lg={4}>
              {renderReview(
                avatar1,
                "just_lansing",
                "I landed a $500 paid collab with a kbeauty and a $800 paid signed contract all with virtual assistant pitching me!",
              )}
            </Grid>
            <Grid item xs={12} lg={4}>
              {renderReview(
                avatar2,
                "itsalexandrapage",
                "Just locked in a partnership for Dr Brandt Skincare for nearly 4 figures 😍 after only a month using Bento's VA. I've recevied plenty of gifted PR from the VA as well, but this is my first paid deal. So happy!",
              )}
            </Grid>
            <Grid item xs={12} lg>
              {renderReview(
                avatar3,
                "Carmina | UGC Creator",
                "Okay Bento's VA Pitching Service update: I just landed $700 worth of collabs today. Bento started sending outbounds for me 15 days ago, so after warming my account, negotiating, and everything, I think they did pretty good! 🧵",
              )}
            </Grid>
          </Grid>
        </>
      }
      fromRoutes={`${routes.va}`}
      plan={Plans.VA_YEARLY}
      notQualified={Boolean(currentOrg?.isVaUser)}
    />
  );
};

export default VaPlanSplashPage;
